import _export from '../internals/export.js';
import functionUncurryThis from '../internals/function-uncurry-this.js';
import notARegexp from '../internals/not-a-regexp.js';
import requireObjectCoercible$1 from '../internals/require-object-coercible.js';
import toString$1 from '../internals/to-string.js';
import correctIsRegexpLogic from '../internals/correct-is-regexp-logic.js';

var $ = _export;
var uncurryThis = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$1;
var toString = toString$1;
var correctIsRegExpLogic = correctIsRegexpLogic;
var stringIndexOf = uncurryThis(''.indexOf); // `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes

$({
  target: 'String',
  proto: true,
  forced: !correctIsRegExpLogic('includes')
}, {
  includes: function includes(searchString
  /* , position = 0 */
  ) {
    return !!~stringIndexOf(toString(requireObjectCoercible(this)), toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
  }
});
